import { getApiOrigin } from '@/config/env';

export type PrevBrandItem = {
  brand: string;
  variants: string[];
};

export async function fetchCatBrands(category?: string): Promise<PrevBrandItem[]> {
  const params = category ? `?category=${encodeURIComponent(category)}` : '';
  const res = await fetch(`${getApiOrigin()}/api/v1/cat-brands${params}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    throw new Error('Unable to load brand list.');
  }

  const data = (await res.json()) as { brands?: Array<{ brand?: unknown; variants?: unknown }> };
  const raw = Array.isArray(data.brands) ? data.brands : [];

  return raw
    .map((item) => {
      const brand = typeof item.brand === 'string' ? item.brand.trim() : '';
      const variants = Array.isArray(item.variants)
        ? item.variants.filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
        : [];
      return { brand, variants };
    })
    .filter((item) => item.brand.length > 0 && item.variants.length > 0);
}

/** LD brand variants from CatBrand where brand is `LD`. */
export async function fetchLdVariants(): Promise<string[]> {
  const brands = await fetchCatBrands();
  const ld = brands.find((item) => item.brand.toLowerCase() === 'ld');
  return ld?.variants ?? [];
}
